import { useState, useEffect } from "react";
import { message } from "antd";
import { IndoorPositioningStations } from "../../../../api";

// State holds METERS ONLY. Pixel positions are derived at render time by the
// canvas that draws them, so nothing here has to be re-projected when the
// canvas is resized (or, later, zoomed/panned).
export const useStations = (machineID, open) => {
  const [stations, setStations] = useState([]);
  const [placedStations, setPlacedStations] = useState([]);
  const [stationsLoading, setStationsLoading] = useState(false);

  const loadStations = async () => {
    if (!machineID) return;

    setStationsLoading(true);
    try {
      const response = await IndoorPositioningStations.GetStations(machineID);
      if (response.code === 200 && Array.isArray(response.data)) {
        setStations(response.data);
        const placed = response.data
          .filter(
            (s) =>
              s.canvas_x !== null &&
              s.canvas_x !== undefined &&
              s.canvas_y !== null &&
              s.canvas_y !== undefined
          )
          .map((s) => ({
            ...s,
            position_meters: { x: s.canvas_x, y: s.canvas_y },
          }));
        setPlacedStations(placed);
      } else {
        setStations([]);
        setPlacedStations([]);
      }
    } catch (error) {
      console.error("載入基站資料失敗:", error);
      message.error("載入基站資料失敗");
      setStations([]);
      setPlacedStations([]);
    } finally {
      setStationsLoading(false);
    }
  };

  useEffect(() => {
    if (open) {
      loadStations();
    }
  }, [open, machineID]);

  const updateStationInState = (stationId, updates) => {
    setStations((prev) =>
      prev.map((s) => (s.id === stationId ? { ...s, ...updates } : s))
    );
    setPlacedStations((prev) =>
      prev.map((s) => (s.id === stationId ? { ...s, ...updates } : s))
    );
  };

  return {
    stations,
    setStations,
    placedStations,
    setPlacedStations,
    stationsLoading,
    loadStations,
    updateStationInState,
  };
};
